<template>
  <div :class="[classes]" @click="handleClick" @keydown.enter.prevent>
    <div class="relative rounded-none shadow-none !focus:ring-0 !ring-0">
      <Combobox
        v-model="current_value"
        immediate
        :value="modelValue || current_value"
        as="div"
        nullable
        class="relative min-w-max !focus:ring-0 !ring-0"
        @update:model-value="modelUpdated">
        <div
          :class="[
            {
              '!bg-transparent ': !(modelValue
                ? objectType == modelValue?.object_type || undefined == modelValue?.object_type
                  ? modelValue?.[displayAttr]
                  : `${utils.getObjectTypeByType(modelValue?.object_type).label}.${modelValue?.[displayAttr]}`
                : '')
            },
            { '!bg-transparent !text-red-500 text-xl': modelValue?.type == 'operator' },

            { ' !text-md pr-10': modelValue?.display == 'In Date Range' },

            { 'px-4 pr-2': modelValue?.type !== 'operator' },

            { '!-mt-0 !h-8  whitespace-nowrap relative': activeWhenThenCursor },

            { '!-ml-6 pr-5': activeWhenThenCursor && !itemIndex },

            { '!h-8 rounded-l-none pr-4': nestedMetric }
          ]"
          :style="{
            background: colors[modelValue?.type]
          }"
          class="rounded-full !focus:ring-0 !ring-0 h-10 p-0 px-0 pr-0 flex items-center justify-center w-full text-white"
          @click="handleBoxClick">
          {{
            modelValue
              ? objectType == modelValue?.object_type || undefined == modelValue?.object_type
                ? modelValue?.[displayAttr]
                : `${modelValue?.[displayAttr]}`
              : ""
          }}
          <span v-if="modelValue?.type == 'select_operator'"
                class="text-red-500 w-fit cursor-pointer">[{{ $t("Click to select operator") }}]</span>

          <div
            v-if="
              !(modelValue
                ? objectType == modelValue?.object_type || undefined == modelValue?.object_type
                  ? modelValue?.[displayAttr]
                  : `${utils.getObjectTypeByType(modelValue?.object_type).label}.${modelValue?.[displayAttr]}`
                : '') &&
                !show_dropdown &&
                activeCursorIndex == itemIndex &&
                (activeWhenThenCursor ? activeWhenThenCursor == refId : true) &&
                modelValue?.type !== 'select_operator'
            "
            class="text-dark-brand-blue text-2xl absolute animate animate-blinking left-2 top-0"
            :class="[
              { 'left-8': activeWhenThenCursor && !itemIndex && itemIndex !== 0 },
              { 'w-32 !-left-10 !text-transparent !cursor-pointer': functionInput }
            ]">
            |
          </div>
          <div
            v-if="
              modelValue?.type == 'metric' ||
                modelValue?.type == 'forecast_metrics' ||
                modelValue?.type == 'other_metrics' ||
                modelValue?.type == 'date_extractor'
            "
            class="bg-white rounded-full cursor-pointer hover:scale-110 flex w-6 h-6 ml-4 p-1.5 relative items-center justify-center transition-all"
            @click.stop="handleXButtonClicked">
            <X class="w-6 h-6" color="black" />
          </div>
        </div>
        <transition name="fade" mode="out-in" duration="100">
          <div
            v-if="
              show_dropdown &&
                !(modelValue
                  ? objectType == modelValue?.object_type || undefined == modelValue?.object_type
                    ? modelValue?.[displayAttr]
                    : `${utils.getObjectTypeByType(modelValue?.object_type).label}.${modelValue?.[displayAttr]}`
                  : '')
            "
            :style="{ background: colors[active_formula_item?.value] }"
            class="w-[320px] rounded-lg !focus:ring-0 !ring-0 -mt-10 z-50 bg-white">
            <div class="p-2 !focus:ring-0 !ring-0" :class="[{ 'border rounded-md': !active_formula_item }]">
              <div class="flex items-center space-x-2 !focus:ring-0 !ring-0">
                <ComboboxInput
                  :id="keyId"
                  ref="combo_box_input"
                  :value="query"
                  :auto-focus="true"
                  :label="$t('Search') + ` ${active_formula_item?.label || ''}`"
                  :placeholder="$t('Search') + ` ${active_formula_item?.label || ''}`"
                  autocomplete="off"
                  tabindex="0"
                  :style="{ width: computed_width }"
                  class="text-gray-700 rounded-lg shadow-none h-6 form-input dark:bg-dark-box-background dark:focus:bg-dark-screen-background dark:group-hover:bg-dark-screen-background focus:ring-0 focus:outline-none border-none"
                  :class="[inputClasses]"
                  :display-value="
                    (item) =>
                      modelValue
                        ? objectType == modelValue?.object_type || undefined == modelValue?.object_type
                          ? modelValue?.[displayAttr]
                          : `${utils.getObjectTypeByType(modelValue?.object_type).label}.${modelValue?.[displayAttr]}`
                        : ''
                  "
                  @keydown.stop="handleKeydown"
                  @change="query = $event.target?.value" />

                <X
                  class="w-5 h-5 cursor-pointer hover:scale-125 transition-all"
                  :color="active_formula_item ? 'white' : 'black'"
                  @click="
                    () => {
                      show_dropdown = false
                      query = ''
                      active_formula_item = null
                      selected_item_index = -1
                      $emitter.emit(ALL_EMITTERS.CLEAR_ACTIVE_FORMULA_ITEM)
                    }
                  " />
              </div>
              <div
                :style="{ background: colors[active_formula_item?.value] }"
                :class="`${active_formula_item?.scrollbar_color}`"
                class="z-50 py-1 overflow-auto text-base pr-10 rounded-md dark:bg-dark-screen-background dark:text-white max-h-40 w-full ring-0 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                <nav class="h-full overflow-y-auto">
                  <div
                    v-for="(item, index) in filtered_items"
                    :key="item"
                    :class="`${active_formula_item?.tailwind_hover_color} ${!active_formula_item ? 'hover:bg-gray-100' : ''} ${
                      selected_item_index == index ? (active_formula_item ? active_formula_item.tailwind_color : 'bg-gray-100') : ''
                    }`"
                    class="">
                    <ul role="list" class="relative z-0 pl-0 dark:divide-gray-400">
                      <div
                        as="div"
                        :value="item"
                        @click="
                          () => {
                            current_value = item
                            show_dropdown = false
                            modelUpdated(item)
                          }
                        ">
                        <li :class="[{ 'text-white': active_formula_item }, ' cursor-default relative py-2 pl-2 pr-4 font-normal']">
                          <span v-if="objectType == item.object_type || undefined == item?.object_type" class="flex items-center space-x-2">
                            <div
                              v-if="!active_formula_item"
                              class="flex w-6 h-6 items-center justify-center rounded-full p-1 mr-2"
                              :style="{ background: colors[item?.type] }">
                              <component :is="icons[item?.type]" :color="'white'" />
                            </div>

                            {{ item[labelAttr] }}
                          </span>
                          <span v-else class="flex items-center space-x-2">
                            <div
                              v-if="!active_formula_item"
                              class="flex w-6 h-6 items-center justify-center rounded-full p-1"
                              :style="{ background: colors[item?.type] }">
                              <component :is="icons[item?.type]" :color="'white'" />
                            </div>

                            <span>{{ utils.getObjectTypeByType(item.object_type).label }}</span><span class="font-extrabold">.</span>{{ item[labelAttr] }}
                          </span>
                        </li>
                      </div>
                    </ul>
                  </div>
                </nav>
                <div key="add" value="value">
                  <div
                    class=""
                    :class="[
                      { 'text-white': active_formula_item },
                      `${active_formula_item?.tailwind_hover_color} ${!active_formula_item ? 'hover:bg-gray-100' : ''} : ''`,
                      ' relative py-2'
                    ]"
                    @click="
                      () => {
                        current_value = 'value'
                        modelUpdated('value')
                      }
                    ">
                    <span :class="['absolute inset-y-0 left-0 flex items-center pl-1.5']">
                      <Plus class="w-5 h-5" aria-hidden="true" />
                    </span>
                    <span class="block pl-3 font-semibold truncate ml-6"> {{ query }} </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </Combobox>
    </div>
  </div>
</template>

<script>
import { Clock9, Plus, X } from "lucide-vue-next"
import { Combobox, ComboboxInput, ComboboxOption, ComboboxOptions } from "@headlessui/vue"
import { utils } from "@/store/helpers"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import FormulaOperatorIcon from "@/components/shared/icons/FormulaOperatorIcon.vue"
import FormulaFunctionIcon from "@/components/shared/icons/FormulaFunctionIcon.vue"
import FormulaMetricsIcon from "@/components/shared/icons/FormulaMetricsIcon.vue"
import FormulaForecastMetricIcon from "@/components/shared/icons/FormulaForecastMetricIcon.vue"
import FormulaActivityMetricIcon from "@/components/shared/icons/FormulaActivityMetricIcon.vue"
import FormulaPlatformMetricIcon from "@/components/shared/icons/FormulaPlatformMetricIcon.vue"
import FormulaNestedMetricIcon from "@/components/shared/icons/FormulaNestedMetricIcon.vue"

export default {
  components: {
    FormulaOperatorIcon,
    FormulaFunctionIcon,
    FormulaMetricsIcon,
    FormulaForecastMetricIcon,
    FormulaNestedMetricIcon,
    FormulaActivityMetricIcon,
    Clock9,
    FormulaPlatformMetricIcon,
    X,
    Combobox,
    ComboboxOptions,
    ComboboxOption,
    ComboboxInput,
    Plus
  },
  props: {
    removeGroupItems: null,
    compareOperators: null,
    groupKeyRemoved: null,
    activeWhenThenCursor: null,
    refId: null,
    functionInput: null,
    lengthOfFormula: null,
    modelValue: {
      type: Object,
      required: false,
      default: null
    },
    items: {
      type: Array,
      required: true
    },

    classes: {
      type: String,
      required: false,
      default: ""
    },
    inputClasses: {
      type: String,
      required: false,
      default: ""
    },

    displayAttr: {
      type: String,
      default: "display"
    },
    labelAttr: {
      type: String,
      default: "label"
    },
    keyId: {
      type: String,
      default: null
    },
    objectType: {
      type: String,
      default: null
    },
    isLastInput: {
      type: Boolean,
      default: false
    },
    nestedMetric: null,
    itemIndex: null,
    activeCursorIndex: null
  },
  emits: [
    "changed",
    "focus",
    "update:modelValue",
    "update:focusing",
    "update:activeWhenThenCursor",
    "update:activeCursorIndex",
    "add",
    "remove"
  ],

  data() {
    return {
      utils,
      query: "",

      initial_value: null,
      current_value: null,
      show_dropdown: false,
      active_formula_item: null,
      block_click_trigger: false,
      ALL_EMITTERS,
      selected_item_index: -1
    }
  },
  computed: {
    colors() {
      return {
        operator: "#FF767E",
        number: "#FF767E",
        function: "#2DA7D7",
        cases: "#FF767E",
        metric: "#B91979",
        metrics: "#B91979",
        forecast_metric: "#B171F9",
        forecast_metrics: "#B171F9",
        activity_metric: "#27C884",
        other_metrics: "#27C884",
        date_extractor: "#FFBE15",
        platform_metric: "#07455D",
        nested_metric: "#2645B4"
      }
    },

    icons() {
      return {
        operator: "FormulaOperatorIcon",
        number: "FormulaOperatorIcon",
        function: "FormulaFunctionIcon",
        cases: "FormulaOperatorIcon",
        metric: "FormulaMetricsIcon",
        metrics: "FormulaMetricsIcon",
        forecast_metrics: "FormulaForecastMetricIcon",
        other_metrics: "FormulaActivityMetricIcon",
        date_extractor: "Clock9",
        platform_metric: "FormulaPlatformMetricIcon",
        nested_metric: "FormulaNestedMetricIcon"
      }
    },
    computed_width() {
      return this.modelValue?.value || this.query
        ? `${Math.max(this.modelValue?.display?.length, this.modelValue?.value?.length, this.query?.length) * 8 + 40}px`
        : "100%"
    },
    filtered_items() {
      let items_calc = this.$utils.clone(this.items)

      if (this.modelValue?.type == "select_operator" && this.compareOperators?.length) {
        items_calc = this.$utils.clone(this.compareOperators.filter((item) => item[this.labelAttr]))
      }

      if (this.modelValue?.type !== "select_operator") {
        this.$store.state.object_types.forEach((object_type) => {
          if (!items_calc.filter((i) => i.value == object_type.value).length) {
            if (this.query) {
              if (object_type?.type.includes(this.query)) {
                items_calc.push({
                  type: "nested_metric",
                  display: object_type?.type,
                  value: object_type?.type,
                  mapped_func: object_type?.type,
                  label: object_type?.type
                })
              }
            } else {
              items_calc.push({
                type: "nested_metric",
                display: object_type?.type,
                value: object_type?.type,
                mapped_func: object_type?.type,
                label: object_type?.type
              })
            }
          }
        })
      }

      if (!this.query) {
        items_calc = items_calc.filter((item) =>
          item?.type && this.active_formula_item
            ? item?.type ==
              (this.active_formula_item?.filter_field ? this.active_formula_item?.filter_field : this.active_formula_item?.value)
            : true
        )
      } else {
        items_calc = items_calc.filter(
          (item) =>
            (item?.type && this.active_formula_item
              ? item?.type ==
                (this.active_formula_item?.filter_field ? this.active_formula_item?.filter_field : this.active_formula_item?.value)
              : true) &&
            (item[this.displayAttr].toLowerCase().includes(this.query.toLowerCase()) ||
              this.objectType?.includes(this.query.toLowerCase()) ||
              item[this.labelAttr].toLowerCase().includes(this.query.toLowerCase()))
        )
      }

      return items_calc
    }
  },
  watch: {
    groupKeyRemoved() {
      if (this.groupKeyRemoved == this.modelValue.group_key) {
        this.$emit("remove")
      }
    },
    show_dropdown() {
      this.$emitter.emit(ALL_EMITTERS.SHOW_DROPDOWN_ACTIVE, this.show_dropdown)
    },

    filtered_items() {
      this.selected_item_index = -1
    }
  },
  created() {
    this.initial_value = utils.clone(this.modelValue)
    this.register_listeners()
  },
  activated() {
    this.register_listeners()
  },
  mounted() {
    this.register_listeners()
  },
  unmounted() {
    this.unregister_listeners()
  },
  deactivated() {
    this.unregister_listeners()
  },

  methods: {
    handleXButtonClicked() {
      this.$emit("remove")
      if (this.modelValue?.group_key) {
        this.removeGroupItems(this.modelValue.group_key)
      }
    },
    handleClick() {
      if (this.refId) {
        this.$emit("update:activeWhenThenCursor", this.refId)
      }
    },
    handleBoxClick() {
      if (this.itemIndex == this.activeCursorIndex || this.modelValue?.type == "select_operator") {
        this.show_dropdown = !this.show_dropdown
        this.handleFocusComboBox()
      } else {
        this.$emit("update:activeCursorIndex", this.itemIndex)
      }
    },
    handleKeydown(e) {
      if (e.key == "Enter") {
        let index = 0

        if (this.selected_item_index > 0) {
          index = this.selected_item_index
        }
        this.current_value = this.filtered_items[index]
        this.modelUpdated(true)
      }
      if (e.key == "ArrowDown" && this.selected_item_index < this.filtered_items.length - 1) {
        this.selected_item_index += 1
      }

      if (e.key == "ArrowUp" && this.selected_item_index !== 0 && this.selected_item_index !== -1) {
        this.selected_item_index -= 1
      }

      if (e.key == "Backspace" && !this.query) {
        this.show_dropdown = false
      }
    },
    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.CLICKFORMULAITEM, (item) => {
        this.active_formula_item = item

        if (
          (this.refId ? this.refId == this.activeWhenThenCursor : true) &&
          !this.functionInput &&
          this.activeCursorIndex == this.itemIndex &&
          this.active_formula_item
        ) {
          this.show_dropdown = true
          this.handleFocusComboBox()
        }
      })
      this.$emitter.on(ALL_EMITTERS.BACKSPACECLICKFORMULA, () => {
        if (
          !this.modelValue.group_key &&
          !this.functionInput &&
          !this.show_dropdown &&
          this.activeCursorIndex == this.itemIndex &&
          this.activeCursorIndex !== -1 &&
          (this.refId ? this.refId == this.activeWhenThenCursor : true)
        ) {
          setTimeout(() => {
            this.$emit("remove")
          }, 200)
        }
      })

      this.$emitter.on(ALL_EMITTERS.KEYCLICKFORMULA, (word) => {
        if (word.includes("ArrowLeft")) {
          if (this.activeCursorIndex !== -1 && (this.refId ? this.refId == this.activeWhenThenCursor : true)) {
            this.$emit("update:activeCursorIndex", this.activeCursorIndex - 1)
          }
        } else if (word.includes("ArrowRight")) {
          if (this.activeCursorIndex < this.lengthOfFormula - 1 && (this.refId ? this.refId == this.activeWhenThenCursor : true)) {
            this.$emit("update:activeCursorIndex", this.activeCursorIndex + 1)
          }
        } else {
          const hot_keys = ["Alt", "Control", "metricValue", "Tab", "CapsLock", "ContextMenu", "Escape", "Help", "Home", "Clear", "Meta"]
          if (!hot_keys.includes(word)) {
            if (
              !this.block_click_trigger &&
              this.activeCursorIndex == this.itemIndex &&
              !this.functionInput &&
              (this.refId ? this.refId == this.activeWhenThenCursor : true)
            ) {
              this.block_click_trigger = true
              if (this.isLastInput) {
                this.show_dropdown = true
                this.handleFocusComboBox()
              }

              setTimeout(() => {
                this.query = word
                this.block_click_trigger = false
              }, 100)
            }
          }
        }
      })
    },
    unregister_listeners() {
      // this.$emitter.off(ALL_EMITTERS.CLICKFORMULAITEM)
      // this.$emitter.off(ALL_EMITTERS.KEYCLICKFORMULA)
      // this.$emitter.off(ALL_EMITTERS.BACKSPACECLICKFORMULA)
    },

    handleFocusComboBox() {
      setTimeout(() => {
        this.$refs.combo_box_input?.el?.focus()
      }, 500)
    },
    modelUpdated(item) {
      if (this.modelValue?.value || item) {
        if (!this.current_value) {
          this.current_value = "value"
        }
        if (this.isLastInput) {
          if (this.current_value == "value") {
            this.$emit("add", { value: this.query, display: this.query, type: "input", key: utils.generateRandomKey() })
          } else {
            this.$emit("add", this.current_value)
          }
        } else {
          if (this.current_value == "value") {
            this.$emit("update:modelValue", { value: this.query, display: this.query, type: "input", key: this.modelValue.key })
          } else {
            this.$emit(
              "update:modelValue",
              this.modelValue.type == "select_operator" ? { ...item, group_key: this.modelValue.group_key } : this.modelValue
            )
          }
        }

        this.query = ""

        setTimeout(() => {
          this.show_dropdown = false
          this.$emitter.emit(ALL_EMITTERS.SHOW_DROPDOWN_ACTIVE, this.show_dropdown)
        }, 600)

        this.active_formula_item = null
        this.selected_item_index = -1

        this.$emitter.emit(ALL_EMITTERS.CLEAR_ACTIVE_FORMULA_ITEM)
      }
    }
  }
}
</script>
